import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const ForgotPasswordOtpSend = createAsyncThunk(
  "client/send-otp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/customers/api/v1/send-otp`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Forgot password otp send  API Response:", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to forgot password otp send"
      );
    }
  }
);

export const SingUp_ForgotPasswordOtpVerify = createAsyncThunk(
  "client/verify-otp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/customers/api/v1/verify-Customer`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Forgot password otp verify API Response:", response);
      return response.data; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to forgot password otp verify"
      );
    }
  }
);

// submit new password
export const ForgotPasswordSubmit = createAsyncThunk(
  "client/change-password",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/customers/api/v1/change-password`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message ||
          "Failed to forgot password submit new password"
      );
    }
  }
);
